// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__aedpy","itemSelecionado":"style_itemSelecionado__3185R","itemCompletado":"style_itemCompletado__fkoGw","concluido":"style_concluido__3cdSk"};